(function () {
  'use strict';

  const KEYS = {
    backspace: 8,
    tab: 9,
    enter: 13,
    escape: 27,
    space: 32,
    up: 38,
    down: 40,
    left: 37,
    right: 39,
    delete: 46,
    column: 186,
    comma: 188
  };

  angular.module('ringbaPortal').component('tagList', {
    bindings: {
      tags: '=',
    },
    controller: TagListController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/tag-list/tag-list.view.html'
  });

  function TagListController(
    _,
    tagService,
    accountsService,
    $timeout,
    $window
  ) {
    'ngInject';

    let promiseExistingTags = null;
    const vm = this;

    vm.textName = '';
    vm.textValue = '';
    vm.tagNameValidationTooltip = '<span class="text-danger f-s-11">Tag name cannot contain special characters(except \'-\' and \'_\') and spaces</span>';

    vm.$onChanges = onChanges;
    vm.AddNewTag = AddNewTag;
    vm.GetFilteredExistingTagNames = GetFilteredExistingTagNames;
    vm.NameSelected = NameSelected;
    vm.HandleNameKeyDown = HandleNameKeyDown;
    vm.HandleValueKeyDown = HandleValueKeyDown;
    vm.HandleClickOnInputs = HandleClickOnInputs;
    vm.removeBorder = removeBorder;

    function onChanges() {
      if(vm.tags == null)
        vm.tags = [];
    }

    function GetFilteredExistingTagNames(text)
    {
      text = text && text.trim();

      return _loadExistingTagNamesOrGetFromCache().then(function(tags){
        try {
          if (vm.tagForm.txtName.$error.pattern) {
            return [];
          }
        } catch {
          // Do nothing if exception caught
        }

        let tagAlreadyExists = false;

        const selectedTagNames = vm.tags ? _.map(vm.tags, 'tagName' ) : [];
        const allTagNamesToFilter = _.union( tags || [], selectedTagNames );

        const filtered = _.filter(allTagNamesToFilter, function(item){
          const lowcase = item.toLowerCase();

          tagAlreadyExists |= item == text;

          return lowcase && lowcase.indexOf(text) > -1;
        });

        const sorted = _.sortBy(filtered);
        const result = _.take( sorted, 10 );

        if (!tagAlreadyExists && text) {
          result.push(text);
        }
        return result;
      });
    }

    function AddNewTag(){
      const tag = {
        tagName: vm.textName,
        tagValue: vm.textValue
      };

      vm.tags.push(tag);

      vm.textName = '';
      vm.textValue = '';

      _focusNameInput();
    }

    function NameSelected(/*$item, $model, $label, $event*/){
      _focusValueInput();
    }

    function HandleNameKeyDown($event)
    {
      const key = $event.keyCode;

      if(key == KEYS.column)
      {
        $event.preventDefault();
        $event.stopPropagation();

        _focusValueInput().then(function(){
          _closeAutocomplete($event.target);
        });
      } else if( key == KEYS.right && !$event.shiftKey && $event.target.selectionStart == $event.target.selectionEnd && $event.target.selectionStart == $event.target.value.length ){
        $event.preventDefault();
        $event.stopPropagation();
        _focusValueInput().then(function(input){
          if(input && input.value)
          {
            input.setSelectionRange(0,0);
          }
        });
      }
    }

    function HandleValueKeyDown($event)
    {
      const key = $event.keyCode;

      if( key == KEYS.backspace )
      {
        if(!vm.textValue || ( $event.target.selectionStart == 0 && $event.target.selectionEnd == 0 ))
        {
          $event.preventDefault();
          $event.stopPropagation();
          _focusNameInput();
        }
      } else if( key == KEYS.left && !$event.shiftKey && $event.target.selectionStart == $event.target.selectionEnd && $event.target.selectionStart == 0 ){
        $event.preventDefault();
        $event.stopPropagation();
        _focusNameInput().then(function(input){
          if(input && input.value)
          {
            const length = input.value.length;
            input.setSelectionRange(length, length);
          }
        });
      }
    }

    function HandleClickOnInputs($event){
      if ($event && $event.target && $event.target.disabled) {
        _focusNameInput();
      }
      if ($($event.target).hasClass('form-control')) {
        $($event.currentTarget).addClass('border-primary');
      }
    }

    function removeBorder($event) {
      $($event.target.parentElement).removeClass('border-primary');
    }


    function _loadExistingTagNames()
    {
      return tagService.getNumberTags(accountsService.currentAccountId).then(function(tags){
        const loaded = [];

        tags.forEach(function(tag){
          loaded.push(tag.tagName);
        });

        if(vm.tags)
        {
          vm.tags.forEach(function(tag){
            loaded.push(tag.tagName);
          });
        }
        return _.uniq(loaded);
      });
    }

    function _loadExistingTagNamesOrGetFromCache(){
      if(promiseExistingTags) return promiseExistingTags;

      promiseExistingTags = _loadExistingTagNames();
      return promiseExistingTags;
    }

    function _closeAutocomplete(elementNameInput) {
      const eventEsc = angular.element.Event('keydown');
      eventEsc.which = 27;
      eventEsc.shiftKey = false;
      angular.element(elementNameInput).trigger(eventEsc);
    }

    function _focusNameInput() {
      return _focusElementById('txtName');
    }

    function _focusValueInput() {
      return _focusElementById('txtValue');
    }

    function _focusElementById(elementId) {
      // TODO: replace this with something that is angular-blessed
      return $timeout(function () {
        const element = $window.document.getElementById(elementId);
        if (element)
          element.focus();

        return element;
      }, 100);
    }

  }

})();
